import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withIncrementalHydration } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { provideYConfig, YConfig } from 'angular-yandex-maps-v3';
import { HttpErrorInterceptor } from './interceptors/http-error.interceptor';
import { provideHighcharts } from 'highcharts-angular';

const config: YConfig = {
  apikey: '013af36d-5ca0-40fc-9b6c-c49edccd223d',
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withIncrementalHydration()),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    provideAnimationsAsync(),
    provideEnvironmentNgxMask(),
    provideHighcharts(),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    provideYConfig(config),
  ],
};
